__turbopack_context__.v({
  "root": "SharingTypeahead-module__RlymuW__root",
  "typeaheadItem": "SharingTypeahead-module__RlymuW__typeaheadItem",
  "typeaheadItemDisabled": "SharingTypeahead-module__RlymuW__typeaheadItemDisabled",
  "typeaheadItemEveryone": "SharingTypeahead-module__RlymuW__typeaheadItemEveryone",
});
